import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false
};

export const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    changeIsLoading: (state, action) => {
      state.isLoading = action.payload;
    }
  }
});

export const { changeIsLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
